import { Dialog, DialogTitle, DialogContent, Typography, DialogActions, Button } from '@mui/material'
import { FC } from 'react'

interface DeleteSchedulerDialogProps {
  isOpen: boolean
  isDeleting: boolean
  onClose: () => void
  onConfirm: () => void
}

export const DeleteSchedulerDialog: FC<DeleteSchedulerDialogProps> = ({ isOpen, isDeleting, onClose, onConfirm }) => {
  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          lineHeight: 'var(--line-height-s, 1.5rem)',
          letterSpacing: 'var(--letter-spacing-none, 0rem)'
        }}
      >
        Delete Scheduled Change
      </DialogTitle>
      <DialogContent>
        <Typography
          sx={{
            fontSize: 'var(--size-xs)',
            fontWeight: '300',
            lineHeight: 'var(--line-height-s, 1.125rem)',
            letterSpacing: 'var(--letter-spacing-none, 0rem)'
          }}
        >
          Are you sure you want to delete this scheduled address change?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ padding: 2 }}>
        <Button variant="outlined" disabled={isDeleting} onClick={onClose} data-testid="cancel-delete">
          No, Back
        </Button>
        <Button variant="outlined" loading={isDeleting} onClick={onConfirm} data-testid="confirm-delete">
          Yes, Delete
        </Button>
      </DialogActions>
    </Dialog>
  )
}
